export default __webpack_public_path__ + "article2.02143fbb.svg";